<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <!--template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template--> 
      <v-card>
        <v-list
          three-line
          subheader
          v-if="formData"
        >
          <v-list-item style="width: 100%;">
        <center style="width:100%;">
          <v-img v-if="img" :src="img" style="height:150px;height:auto;"/>
            <p style="margin: 0;" :style="{ color: color }">{{ `Bienvenido a ${clientName}` }}</p>
          <span style="color:#566573;">{{getTranslation(title, locale)}}</span>
        </center>
          </v-list-item>
          <v-list-item>
            <v-list-item-content v-if="formData.name">
              <v-list-item-title>{{getTranslation(name, locale)}}</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field
                  v-model="values.name"
                  outlined
                  dense
                  hide-details
                />
                  <small v-if="err.indexOf('name')>=0" style="color: red;">Error</small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content v-if="formData.phone">
              <v-list-item-title>{{getTranslation(phone, locale)}}</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field
                  v-model="values.phone"
                  outlined
                  dense
                  hide-details
                />
                  <small v-if="err.indexOf('phone')>=0" style="color: red;">Error</small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content v-if="formData.email">
              <v-list-item-title>{{getTranslation(email, locale)}}</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field
                  v-model="values.email"
                  outlined
                  dense
                  hide-details
                />
                  <small v-if="err.indexOf('email')>=0" style="color: red;">Error</small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content >
              <v-list-item-subtitle>
                <v-layout wrap>
                  <v-flex xs1>
                    <v-checkbox v-model="values.terms" hide-details />
                  </v-flex>
                  <v-flex xs11 style="padding-top:25px;">
                    <terms-control 
                      :terms="terms"
                      :onOK="handleOKTerms"
                      :locale="locale"
                      :color="color"
                    />
                  </v-flex>
                </v-layout>
                  <small v-if="err.indexOf('terms')>=0" style="color: red;">Error</small>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!--v-list-item v-if="formData">
            <v-list-item-content>
              <v-list-item-title>info</v-list-item-title>
              <v-list-item-subtitle>
                {{formData}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item-->
        </v-list>
        <!--v-divider></v-divider>
        <v-list
          three-line
          subheader
        >
          <v-subheader>General</v-subheader>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="notifications"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Notifications</v-list-item-title>
              <v-list-item-subtitle>Notify me about updates to apps or games that I downloaded</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="sound"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Sound</v-list-item-title>
              <v-list-item-subtitle>Auto-update apps at any time. Data charges may apply</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <v-checkbox v-model="widgets"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Auto-add widgets</v-list-item-title>
              <v-list-item-subtitle>Automatically add home screen widgets</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-->
        <center>
          <v-btn 
            @click="handleSend"
            :color="color"
            dark
          >
            {{ getTranslation(send, locale) }}
          </v-btn>
        </center>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import apiWelcomeForm from '@/services/apiWelcomeForm'
import utils from '@/services/utils'
import TermsControl from './Terms'
export default {
  components: {
    TermsControl,
  },
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    locale: {
      type: String,
      default: 'es',
    },
    config: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    Logo: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      dialog: false,
      formData: null,
      notifications: false,
      sound: true,
      widgets: false,
      fields: null,
      values: { terms: false },
      terms: '',
      err: [],
      welcomeFormHist: [],
    }
  },
  computed: {
    title () {
      return { es: 'Complete el formulario para acceder al contenido', }
    },
    name () {
      return { es: 'Nombre', }
    },
    email () {
      return { es: 'Email', }
    },
    phone () {
      return { es: 'Teléfono', }
    },
    send () {
      return { es: 'Enviar' }
    },
    img () {
      return this.Logo
    },
    clientName () {
      return this.config.Name
    },
  },
  mounted () {
    this.welcomeFormHist = utils.getCustomToken('welcomeForm') ? utils.getCustomToken('welcomeForm').split(',') : [] 
    if (this.welcomeFormHist.indexOf(this.workspaceID) === -1) this.handleGetData()
  },
  methods: {
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    async handleGetData() {
      this.formData = await apiWelcomeForm.getFormFields(this.workspaceID)
      delete this.formData.isWelcomeForm
      this.terms = this.formData.terms.es
      this.fields = Object.keys(this.formData)
      if (this.fields) this.dialog = true
    },
    handleOKTerms () {
      this.values.terms = true
    },
    async handleSend () {
      this.err = []
      for(const item of this.fields) {
        if(!this.values[item] || this.values[item].length === 0) this.err.push(item)
      }
      if (this.err.length === 0) {
        if (await apiWelcomeForm.sendResult(this.workspaceID, this.values)) {
          this.welcomeFormHist.push(this.workspaceID)
          utils.setCustomToken('welcomeForm', this.welcomeFormHist.join(','))
          this.dialog = false
        }
      }
    },
  },
}
</script>

